import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch, useLocation } from "react-router-dom";
import qs from "query-string";
import {
  IonButton,
  IonList,
  IonLabel,
  IonToast,
  IonText,
  IonInput,
} from "@ionic/react";
import PageContainer from "Components/Global/PageContainer";
import "Styles/Questionnaire/QuestionnaireContainer.scss";
import { submit_phone } from "Store/user/thinks";
import {
  format_us_phone_number,
  is_valid_us_phone_number,
  normalize_us_phone_number,
  resolve_input_element_value,
  US_PHONE_DISPLAY_PATTERN,
} from "Utils";

const QuestionnaireContainer = () => {
  const location = useLocation();
  const { is_new_project, saved } = qs.parse(location.search);
  const is_save_success = saved;
  return (
    <PageContainer id="questionnaire" pageContainerClassName="questionnaire">
      <QuestionnaireForm is_new_project={is_new_project} />
      {is_new_project && (
        <IonToast
          className="questionnaire-toast"
          isOpen={true}
          header="Your project details were successfully saved!"
          message="Add your U.S. phone number to receive SMS notifications when you have new messages."
          duration={3000}
          position="top"
          buttons={[
            {
              text: "OK",
              role: "cancel",
            },
          ]}
        />
      )}
      {is_save_success && !is_new_project && (
        <IonToast
          className="questionnaire-toast"
          isOpen={true}
          header="Settings successfully saved!"
          message="Your SMS notification settings were successfully saved."
          duration={1000}
          position="top"
          buttons={[
            {
              text: "OK",
              role: "cancel",
            },
          ]}
        />
      )}
    </PageContainer>
  );
};

const QuestionnaireForm = ({ is_new_project }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const match = useRouteMatch();
  const { user } = useSelector((state) => state);
  const { project_objectId } = match.params;
  const { is_phone_submission_request_busy } = user;
  const { phone, is_admin } = user.data;
  const [inputted_phone_value, set_inputted_phone_value] = useState(
    normalize_us_phone_number(phone)
  );
  const phone_change_handler = (e) => {
    const value = resolve_input_element_value(e.target);

    set_inputted_phone_value(normalize_us_phone_number(value));
  };
  const is_phone_valid = is_valid_us_phone_number(inputted_phone_value);
  const submit_handler = async (e) => {
    e.preventDefault();

    const phone_saved = await dispatch(submit_phone(inputted_phone_value));
    if (!phone_saved) return;

    if (is_new_project) {
      history.push(`/projects/${project_objectId}?is_new_project=true`);
    } else {
      history.replace("/questionnaire/" + project_objectId + "?saved=true");
    }
  };

  return (
    <>
      <form onSubmit={submit_handler}>
        <IonList lines="none">
          <PhoneField
            value={inputted_phone_value}
            change_handler={phone_change_handler}
            busy={is_phone_submission_request_busy}
            is_admin={is_admin === true}
          />
        </IonList>
        <br />
        <IonButton
          className="submit-button"
          expand="block"
          disabled={is_phone_submission_request_busy || !is_phone_valid}
          type="submit"
        >
          Save settings
        </IonButton>
      </form>
    </>
  );
};

const PhoneField = ({ value, change_handler, busy, is_admin }) => {
  return (
    <div className="phone-field">
      <IonLabel className="ion-text-wrap questionnaire-question">
        {is_admin
          ? "Enter this administrator's U.S. phone number. It will receive SMS notifications when a client sends a message."
          : "Enter your U.S. phone number to receive SMS notifications when an administrator sends a message."}
        <IonText color="primary">*</IonText>
      </IonLabel>
      <IonInput
        className="phone-input"
        value={format_us_phone_number(value)}
        onIonChange={change_handler}
        type="tel"
        autocomplete="tel"
        inputMode="numeric"
        pattern={US_PHONE_DISPLAY_PATTERN}
        maxlength={17}
        placeholder="+1 (555) 555-5555"
        disabled={busy}
        required
      />
      <IonText className="format-tooltip" color="secondary">
        U.S. numbers only. Format: <em>+1 (555) 555-5555</em>.
      </IonText>
    </div>
  );
};

export default QuestionnaireContainer;
